/**
 * RESPONSIBILITY: the @Repeats column of a @List row.
 *
 * The same picker the section control draws. Before it, this column fell through to a
 * text box, which asked whoever added an event to write cron.
 */
import { RepeatPicker } from './repeat-picker';
import { str, type Cell } from './cell-types';

const RepeatCell: Cell['render'] = ({ value, onChange, id }) => (
  <RepeatPicker id={id} value={str(value)} onChange={onChange} />
);

export const repeatCell: Cell = { render: RepeatCell, basis: () => '100%' };
